import { Component, Input, EventEmitter, Output } from '@angular/core';
import { FormArray, FormGroup } from '@angular/forms';
import { Observable } from 'rxjs';
import { USER_ROLES } from 'src/app/core/constants/cms-user-roles';
import { IAllowableState } from 'src/app/core/dtos/interfaces/i-allowable-state';
import { ContentStatus } from 'src/app/shared/enums/content-status';
import { UserRolesService } from 'src/app/shared/services/user-roles.service';

@Component({
  selector: 'app-content-state-controls',
  templateUrl: './content-state-controls.component.html',
  styleUrls: ['./content-state-controls.component.scss'],
})
export class ContentStateControlsComponent {
  @Input() allowableNextStates: IAllowableState[];
  @Input() isProcessingStateChange: boolean;
  @Input() isPublished: boolean;
  @Input() isSpiked: boolean;
  @Input() form: FormGroup;
  @Input() isSaving!: boolean;
  @Output() handleStateChange = new EventEmitter<ContentStatus>();
  @Output() handleReEditClick = new EventEmitter();
  @Output() handleReactivateClick = new EventEmitter();

  selectedState: ContentStatus;

  canCreateNewVersion$: Observable<boolean>;

  constructor(userRolesService: UserRolesService) {
    this.canCreateNewVersion$ = userRolesService.isUserInRole(
      USER_ROLES.CanCreateNewVersions
    );
  }

  onChangeState(selectedStateChange: ContentStatus): void {
    this.selectedState = selectedStateChange;
    this.handleStateChange.emit(selectedStateChange);
  }

  onReEdit(): void {
    this.handleReEditClick.emit();
  }

  onReactivate(): void {
    this.handleReactivateClick.emit();
  }
}
